var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "page_card",
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.onClick.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "page_card_inner_wrap" }, [
        _c(
          "a",
          {
            staticClass: "page_card_title",
            attrs: { href: _vm.model.relative_url_path },
          },
          [_vm._v("\n            " + _vm._s(_vm.model.title) + "\n        ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "page_card_breadcrumb" }, [
          _vm._v("\n            " + _vm._s(_vm.getBreadcrumbs) + "\n        "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card_page_summary" }, [
          _vm._v("\n            " + _vm._s(_vm.model.summary) + "\n        "),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }